// extracted by mini-css-extract-plugin
module.exports = {"container":"MainGrid_container__5WomS","content":"MainGrid_content__oNpxi","section":"MainGrid_section__eR74u"};